import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../store';
import ShopStatisticPage from './ShopStatisticPage';
import { setLastShopTab } from '../../store/main/actionCreators';

const ShopStatistic = () => {
  const dispatch = useAppDispatch();
  const { curProject } = useSelector((state) => state.main);
  const curProjectName = curProject?.name;
  const { curBot } = useSelector((state) => state.bot);

  
  // const curProjectName = 'ozon-quest-dedic';

  useEffect(() => {
    dispatch(setLastShopTab('/shop/statistic'));
    // eslint-disable-next-line
  }, []);

  return (
    <ShopStatisticPage slug={curProjectName || ''} base={curBot.base || ''} />
  );
};

export default ShopStatistic;
